// =============================================================================
// src/features/auth/auth-api-config.ts — Endpoint do servidor local de auth.
//
// SRP: centraliza o endpoint externo (regra 9 do CLAUDE.md) num só lugar,
//   espelhando src/data/explore-live-config.ts. Default localhost:8787 (o
//   `npm run auth:server` do repo); VITE_AUTH_API_URL sobrepõe em deploy.
// =============================================================================

/** Subset de import.meta.env consumido pelo cliente de auth. */
export interface AuthApiEnv {
  /** Base da API de auth (ex.: https://auth.exemplo.com). Ausente -> localhost. */
  readonly VITE_AUTH_API_URL?: string;
}

/** Base default: o servidor local `npm run auth:server` (server/auth-server.ts). */
export const AUTH_API_DEFAULT_BASE_URL = 'http://localhost:8787';

/**
 * Resolve a base da API de auth a partir do ambiente Vite (sem barra final).
 *
 * @example resolveAuthApiBaseUrl({}) // 'http://localhost:8787'
 * @example resolveAuthApiBaseUrl({ VITE_AUTH_API_URL: 'https://x.dev/' }) // 'https://x.dev'
 */
export function resolveAuthApiBaseUrl(env: AuthApiEnv): string {
  const fromEnv = (env.VITE_AUTH_API_URL ?? '').trim();
  if (fromEnv.length === 0) return AUTH_API_DEFAULT_BASE_URL;
  return fromEnv.replace(/\/+$/, '');
}
